import {omit, pick} from 'lodash';
import React from 'react';
import {NewPaymentSource, OptionalAddress} from '../api/generated/index.defs';
import {AnyObject, KeyOf} from '../types';

type Address = {
  address?: OptionalAddress;
};

export type AddressFields = KeyOf<OptionalAddress>[];

export const AddressFields: AddressFields = [
  'streetAddress',
  'streetAddress2',
  'city',
  'state',
  'zipCode',
];

export const Address: React.FC<Address> = ({address}) => {
  if (!address) {
    return null;
  }

  let cityStateZip = '';
  if (address.city || address.state || address.zipCode) {
    let line: string[] = [];
    if (address.city) line.push(address.city);
    if (address.state) line.push(address.state);
    if (line.length) {
      line = [line.join(', ')];
    }
    if (address.zipCode) line.push(address.zipCode);
    cityStateZip = line.join(' ');
  }
  return (
    <div className="address notranslate">
      {address.streetAddress && <div className="street-address">{address.streetAddress}</div>}
      {address.streetAddress2 && <div className="street-address-2">{address.streetAddress2}</div>}
      {cityStateZip && <div className="city-state-zip">{cityStateZip}</div>}
    </div>
  );
};

export function mapPaymentSourceAddress<T = NewPaymentSource>(obj: AnyObject) {
  const address = pick(obj, AddressFields);
  const modifiedPaymentSource = omit(obj, AddressFields) as unknown as NewPaymentSource;

  modifiedPaymentSource.address = address;

  return modifiedPaymentSource as unknown as T;
}
